import * as React from "react";
const defaultRoutingContextValue = [
  { goTo: () => null },
  {
    component: void 0,
    queryParams: {},
    currentRoute: "",
    basePath: ""
  }
];
const RoutingContext = React.createContext(
  defaultRoutingContextValue
);
const useRoutingContext = () => React.useContext(RoutingContext);
export {
  RoutingContext,
  defaultRoutingContextValue,
  useRoutingContext
};
//# sourceMappingURL=context.js.map
